import React from "react";
import PropTypes from "prop-types";
import { SectionContent } from "../common/Section/Section";
import * as S from "../ResultadoSorteiosCapitalizacao/ResultadoSorteiosCapitalizacao.Style";

const StatusContemplacao = ({
  contemplado,
  children,
  contentNaoContemplado,
}) => {
  return (
    <S.StatusContemplacao contemplado={contemplado}>
      <S.StatuContempladoContent as={SectionContent}>
        {contemplado ? (
          <S.ContentContemplado>{children}</S.ContentContemplado>
        ) : (
          <S.ContentNaoContemplado>
            {contentNaoContemplado}
          </S.ContentNaoContemplado>
        )}
      </S.StatuContempladoContent>
    </S.StatusContemplacao>
  );
};

StatusContemplacao.defaultProps = {
  contemplado: false,
};

StatusContemplacao.propTypes = {
  contemplado: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  contentNaoContemplado: PropTypes.element.isRequired,
};

StatusContemplacao.IlustracaoContent = S.IlustracaoContempladoContent;
StatusContemplacao.IlustracaoMobile = S.IlustracaoContempladoSm;
StatusContemplacao.IlustracaoDesktop = S.IlustracaoContempladoLg;

export default StatusContemplacao;
